'use client';
import {
  GetSchemaStructuredData,
  getNewsArticleSchemaStructuredData,
} from './getSchemaStructuredData';
import { useTranslations } from 'next-intl';

const ArticleJsonLdSchema = ({
  content,
  body,
  author,
  channelPref,
}: GetSchemaStructuredData) => {
  const t = useTranslations();
  const { structuredData } = getNewsArticleSchemaStructuredData({
    content,
    body,
    author,
    channelPref,
  });
  structuredData.publisher = {
    '@type': 'Organization',
    name: `TRT ${t('trt-channel')}`,
    logo: {
      '@type': 'ImageObject',
      url: 'https://trt.global/logo.png',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  );
};

export default ArticleJsonLdSchema;
